import { useMemo } from 'react';
import useApiFetch from '@/hooks/useApiFetch';
import candidatesReports from '@/services/candidatesReports';
import { FetchApiIds } from '@/types';
import { getPercentageFromBiggestNumber } from '@/utils/chart';
import AverageTimeChartComponent from './AverageTimeChart.component';

const AverageTimeChartContainer = function (): JSX.Element {
  const chartResponse = useApiFetch(
    FetchApiIds.AVG_TIME_IN_DAYS_CHART,
    candidatesReports.getAverageToAcceptanceOrRejection
  );

  const chartData = useMemo(() => {
    const response = chartResponse?.data ?? {};
    const responseArray = Object.entries(response);
    const responseObject = responseArray.map(([name, total]) => ({
      total,
      name,
    }));
    const responseFormatted = getPercentageFromBiggestNumber(responseObject);
    return responseFormatted;
  }, [chartResponse.data]);

  return (
    <>
      <div data-testid="avarage-time-chart">
        <AverageTimeChartComponent isLoading={chartResponse.isLoading} data={chartData} />
      </div>
    </>
  );
};

export default AverageTimeChartContainer;
